import { pageSize } from "@/config/pagination.config";
import { PaginationState } from "@tanstack/react-table";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

type PreviousEditionsStoreState = {
  editionNameFilter: string;
  resultsFilter: string;
  pagination: PaginationState;
};

type PreviousEditionsStoreActions = {
  actions: {
    setEditionNameFilter: (editionNameFilter: string) => void;
    setResultsFilter: (resultsFilter: string) => void;
    setPagination: (pagination: PaginationState) => void;
    resetFilters: () => void;
  };
};

type PreviousEditionsStore = PreviousEditionsStoreState &
  PreviousEditionsStoreActions;

const defaultState: PreviousEditionsStoreState = {
  editionNameFilter: "",
  resultsFilter: "",
  pagination: {
    pageIndex: 0,
    pageSize,
  },
};

export const previousEditionsStore = create<PreviousEditionsStore>()(
  devtools(
    (set) => ({
      ...defaultState,
      actions: {
        setEditionNameFilter: (editionNameFilter: string) => {
          set({ editionNameFilter });
        },
        setResultsFilter: (resultsFilter: string) => {
          set({ resultsFilter: resultsFilter });
        },
        setPagination: (pagination: PaginationState) => {
          set({ pagination });
        },
        resetFilters: () => {
          set(defaultState);
        },
      },
    }),
    {
      name: "previous-editions-store",
      enabled: !import.meta.env.PROD,
    },
  ),
);

export const usePreviousEditionsEditionNameFilter = () =>
  previousEditionsStore((state) => state.editionNameFilter);

export const usePreviousEditionsResultsFilter = () =>
  previousEditionsStore((state) => state.resultsFilter);

export const usePreviousEditionsPagination = () =>
  previousEditionsStore((state) => state.pagination);

export const usePreviousEditionsActions = () =>
  previousEditionsStore((state) => state.actions);
